import dayjs from "dayjs";

import {
  hideIntercomWidget,
  initIntercomWidget,
  logoutIntercomWidget,
  openIntercomMessenger,
  showIntercomWidget,
  updateIntercomWidget,
} from "./intercom.utils";

export const formatName = (...fragments: (string | null | undefined)[]) => ({
  name: fragments.filter(Boolean).join(" "),
});

export const formatTimestamp = (timestamp: Parameters<typeof dayjs>[0]) => {
  if (!timestamp) {
    return undefined;
  }

  const timePoint = dayjs(timestamp);

  return timePoint.unix();
};

export const initSupportChatWidget = initIntercomWidget;

export const updateSupportChatWidget = updateIntercomWidget;

export const showSupportChatWidget = showIntercomWidget;

export const hideSupportChatWidget = hideIntercomWidget;

export const logoutSupportChatWidget = logoutIntercomWidget;

export const openSupportChatMessenger = openIntercomMessenger;

export const getSupportCenterLinks = () => {
  return {
    helpCenterIndex: "https://intercom.help/repeatmd/en",
    customCategoriesExamples:
      "https://intercom.help/repeatmd/en/articles/9017701-examples-of-custom-categories-on-your-patient-rewards-app",
    membershipsReport: "https://intercom.help/repeatmd/en/articles/8877961-memberships-report",
    redemptionsReport: "https://intercom.help/repeatmd/en/articles/8877997-redemptions-report",
    servicesReport: "https://intercom.help/repeatmd/en/articles/8877955-services-report",
    shopSummaryReport:
      "https://intercom.help/repeatmd/en/articles/8877962-shop-summary-formally-known-as-the-transactions-report",
  };
};
